<template>
    <div class="dorms">
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="nameFilter">Yurt Ara</label>
                    <div class="input-group">
                        <input class="form-control custom-input" type="text" placeholder="Yurt Adı" v-model="nameFilter" @keyup.enter="getDorms">
                        <span class="input-group-btn">
                            <a class="btn btn-primary" style="height: 45px;" @click="getDorms">
                                <i class="fa fa-search" style="vertical-align: -webkit-baseline-middle;"></i>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="dorm_type">Yurt Tipi</label>
                    <select class="form-control custom-input" v-model="dorm_type" @change="getDorms">
                        <option value="">Seçiniz...</option>
                        <option value="1">Erkek Öğrenci Yurdu</option>
                        <option value="2">Kız Öğrenci Yurdu</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="status">Durumu</label>
                    <select class="form-control custom-input" v-model="dorm_status" @change="getDorms">
                        <option value="">Seçiniz...</option>
                        <option value="1">Aktif</option>
                        <option value="0">Pasif</option>
                        <option value="3">Onay Bekleyen</option>
                        <option value="2">Arşivlenmiş</option>
                    </select>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="city">İl</label>
                    <select class="form-control custom-input" v-model="city" @change="getDistrictDorms">
                        <option value="">Seçiniz...</option>
                        <option v-for="city in cities" :key="city.id" :value="city.id">{{ city.name }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="district">İlçe</label>
                    <select class="form-control custom-input" v-model="district" @change="getDorms">
                        <option value="">Seçiniz...</option>
                        <option v-for="district in districts" :key="district.id" :value="district.id">{{ district.name }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"></i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                            <span>Toplam {{ pagination.total || 0 }} sonuç gösteriliyor.</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th>Yurt Tipi</th>
                                    <th>Yurt Adı</th>
                                    <th>İl / İlçe</th>
                                    <th>Durum</th>
                                    <th>İşlemler</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in items" :key="item.id">
                                    <td v-if="item.type">{{ item.type.title }}</td>
                                    <td v-else>Yurt Tipi Belirtilmemiş</td>
                                    <td>{{ item.name }}</td>
                                    <td v-if="item.city && item.district">{{ item.city.name }} / {{ item.district.name }}</td>
                                    <td v-else>Yok</td>
                                    <td v-if="item.is_active == 1"><span class="label label-success">Aktif</span></td>
                                    <td v-else-if="item.is_active == 0"><span class="label label-danger">Pasif</span></td>
                                    <td v-else-if="item.is_active == 2"><span class="label label-warning">Arşivlenmiş</span></td>
                                    <td v-else-if="item.is_active == 3"><span class="label label-info">Onay Bekliyor</span></td>
                                    <td v-else>Yok</td>
                                    <td>
                                        <router-link :to="{ name: 'dorms.update', params: {id: item.id} }" class="btn btn-primary btn-xs">
                                           <span>Düzenle</span></router-link>
                                        /
                                        <button class="btn btn-danger btn-xs" @click="destroy(item)">Sil
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="10" @paginate="fetchPosts()"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Pagination from '@/components/layouts/Pagination'

  export default {
    components: {Pagination},
    data() {
      return {
        nameFilter: '',
        dorm_type: '',
        dorm_status: '',
        city: '',
        district: '',
        icon: 'fa fa-building',
        tableName: 'Yurtlar Tablosu',
        tableDesc: 'Bu tablo sitenizde aktif/pasif olan Yurtları gösterir',
        api: 'dorms/',
        items: [],
        pagination: {
          'current_page': 1,
          'total': 0
        },
        cities: [],
        districts: [],
        queryString: {},
      }
    },

    methods: {
      fetchPosts() {
        this.$Progress.start();
        this.axios.get(this.api, {
          params: {
            page: this.pagination.current_page,
            type: this.dorm_type || '',
            name: this.nameFilter || '',
            city: this.city || '',
            district: this.district || '',
            status: this.dorm_status || '',
          }
        })
            .then(response => {
              this.items = response.data.data.data;
              this.pagination = response.data.pagination;
              this.$Progress.finish()
            })
            // eslint-disable-next-line no-unused-vars
            .catch(error => {
              this.pagination = {'current_page': 1};
              // console.log(error.response.data);
            });
      },
      getDorms() {
        this.pagination = {'current_page': 1};
        this.fetchPosts();
      },
      getCity() {
        this.$Progress.start();
        this.axios.get('cities')
            .then(response => {
              this.cities = response.data;
              this.$Progress.finish();
            });
      },
      getDistrictDorms() {
        this.pagination = {'current_page': 1};
        this.district = '';
        this.fetchPosts();
        this.axios.get('districts?city=' + this.city)
            .then(response => {
              this.districts = response.data.districts;
              this.$Progress.finish();
            });
      },
      destroy(item) {
        this.$swal({
          title: 'Silmek istediğinizden emin misiniz?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Evet',
          cancelButtonText: 'İptal'
        }).then((result) => {
          if (result.value) {
            this.axios.delete(this.api + item.id).then(response => {
              if (response.status == 200) {
                this.$swal(
                    'Başarılı!',
                    'Veri silme işlemi başarılı',
                    'success'
                );
                this.items.splice(this.items.indexOf(item), 1)
              }
            })
          }
        })
      },
    },
    mounted() {
      this.fetchPosts();
      this.getCity();
    },
    computed: {
      upperCase() {
        return this.items.map(item => {
          // console.log(item.first_name);
          return item.first_name.toUpperCase();
        });
      }
    },
  }
</script>

<style scoped>

</style>
